import React from 'react';

import { InputContainer, InputLabel, InputSelectionBox, InputSelectedBox, InputSelectedRadio } from './styles';

export const Checkbox = ({
  checked,
  label,
  onChange,
  disabled = false,
  isDarkMode = false,
  title,
  type = 'button',
}) => {
  const click = () => !disabled && onChange && onChange();
  return (
    <InputContainer title={title}>
      <InputSelectionBox isDarkMode={isDarkMode} checked={checked} disabled={disabled} type={type} onClick={click}>
        <InputSelectedBox checked={checked} />
      </InputSelectionBox>
      <InputLabel isDarkMode={isDarkMode} disabled={disabled} onClick={click}>
        {label}
      </InputLabel>
    </InputContainer>
  );
};

export const CheckboxMark = ({ checked, onChange, disabled = false, isDarkMode = false, type = 'button' }) => {
  const click = () => !disabled && onChange && onChange();
  return (
    <InputSelectionBox isDarkMode={isDarkMode} checked={checked} disabled={disabled} type={type} onClick={click}>
      <InputSelectedBox checked={checked} />
    </InputSelectionBox>
  );
};

export const RadioButton = ({
  checked,
  label,
  onChange,
  disabled = false,
  isDarkMode = false,
  canDeSelect = false,
  type = 'button',
}) => {
  const click = () => (!checked || canDeSelect) && !disabled && onChange && onChange();
  return (
    <InputContainer>
      <InputSelectionBox
        radio
        isDarkMode={isDarkMode}
        checked={checked}
        disabled={disabled}
        type={type}
        onClick={click}
      >
        <InputSelectedRadio checked={checked} />
      </InputSelectionBox>
      <InputLabel isDarkMode={isDarkMode} disabled={disabled} onClick={click}>
        {label}
      </InputLabel>
    </InputContainer>
  );
};

export const RadioButtonMark = ({
  checked,
  onChange,
  disabled = false,
  isDarkMode = false,
  canDeSelect = false,
  type = 'button',
}) => {
  const click = () => (!checked || canDeSelect) && !disabled && onChange && onChange();
  return (
    <InputSelectionBox radio isDarkMode={isDarkMode} checked={checked} disabled={disabled} type={type} onClick={click}>
      <InputSelectedRadio checked={checked} />
    </InputSelectionBox>
  );
};
